import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"
import type { ChatAnalyze } from "../interfaces"

interface ContentTypesTableProps {
  stats: ChatAnalyze.Stats
}

export function ContentTypesTable({ stats }: ContentTypesTableProps) {
  const { mediaTypes, textOnly, total, msgsWithReply, replyRate, forwarded } =
    stats

  const rows = [
    { icon: "💬", label: "Текстовые", count: textOnly },
    ...mediaTypes,
    { icon: "↩️", label: "Ответы (reply)", count: msgsWithReply },
    { icon: "↗️", label: "Пересланные", count: forwarded },
  ]

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700 }}>Тип</TableCell>
            <TableCell sx={{ fontWeight: 700 }} align="right">
              Кол-во
            </TableCell>
            <TableCell sx={{ fontWeight: 700 }} align="right">
              Доля
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.label} sx={{ "&:last-child td": { border: 0 } }}>
              <TableCell>
                {"icon" in row ? row.icon : ""} {row.label}
              </TableCell>
              <TableCell align="right">
                <strong>{row.count.toLocaleString("ru-RU")}</strong>
              </TableCell>
              <TableCell align="right">
                {total ? ((row.count / total) * 100).toFixed(1) : "0.0"}%
                {row.label === "Ответы (reply)" && (
                  <span
                    style={{ opacity: 0.6, marginLeft: 4, fontSize: "0.75em" }}
                  >
                    ({replyRate.toFixed(1)}%)
                  </span>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
